// extracted by mini-css-extract-plugin
export var bubble = "_16-0";
export var container = "_16-f";
export var contrastBorder = "_16-g";
export var greyOut = "_16-2";
export var initialsColor0 = "_16-3";
export var initialsColor1 = "_16-4";
export var initialsColor10 = "_16-d";
export var initialsColor11 = "_16-e";
export var initialsColor2 = "_16-5";
export var initialsColor3 = "_16-6";
export var initialsColor4 = "_16-7";
export var initialsColor5 = "_16-8";
export var initialsColor6 = "_16-9";
export var initialsColor7 = "_16-a";
export var initialsColor8 = "_16-b";
export var initialsColor9 = "_16-c";
export var initialsWrapper = "_16-1";
export var large = "_16-l";
export var medium = "_16-k";
export var mediumSmall = "_16-j";
export var mediumSmallMedium = "_16-o";
export var micro = "_16-h";
export var small = "_16-i";
export var tiny = "_16-n";
export var xTiny = "_16-m";